import axiosInstance from '@/app/api/axiosInstance';
import {
  ItemSalePriceRule,
  ItemSalePriceRuleQueryParams,
  ItemSalePriceRuleListResponse,
  CreateItemSalePriceRuleInput,
  UpdateItemSalePriceRuleInput
} from '@/app/types/itemSalePriceRule';

const BASE_URL = '/item-sale-price-rules/';

// Get a list of item sale price rules with filtering, sorting, and pagination
export async function listItemSalePriceRules(params: ItemSalePriceRuleQueryParams = {}): Promise<ItemSalePriceRuleListResponse> {
  const response = await axiosInstance.get(BASE_URL, { params });
  return response.data;
}

// Get a single item sale price rule by ID
export async function getItemSalePriceRule(id: number): Promise<ItemSalePriceRule> {
  const response = await axiosInstance.get(`${BASE_URL}${id}`);
  return response.data;
}

// Create a new item sale price rule
export async function createItemSalePriceRule(data: CreateItemSalePriceRuleInput): Promise<ItemSalePriceRule> {
  const response = await axiosInstance.post(BASE_URL, data);
  return response.data;
}

// Update an existing item sale price rule
export async function updateItemSalePriceRule(id: number, data: UpdateItemSalePriceRuleInput): Promise<ItemSalePriceRule> {
  const response = await axiosInstance.patch(`${BASE_URL}${id}`, data);
  return response.data;
}

// Delete an item sale price rule
export async function deleteItemSalePriceRule(id: number): Promise<void> {
  await axiosInstance.delete(`${BASE_URL}${id}`);
}

// Get all active sale price rules for a specific item
export async function getActiveRulesForItem(itemId: number): Promise<ItemSalePriceRule[]> {
  try {
    // Using simpler query approach - just filter by item_id
    const params = {
      item_id: itemId,
      is_active: true,
      limit: 100
    };
    
    console.log(`Fetching active rules for item ${itemId}`);
    const response = await axiosInstance.get(BASE_URL, { params });
    console.log('API Response for active rules:', response.data);
    
    // Make sure we have items in the response and return them
    if (response.data && Array.isArray(response.data.items)) {
      console.log(`Found ${response.data.items.length} rules for item ${itemId}`);
      return response.data.items;
    } else if (response.data && Array.isArray(response.data)) {
      // Handle case where API might return array directly
      console.log(`Found ${response.data.length} rules for item ${itemId} (array format)`);
      return response.data;
    }
    
    console.log(`No rules found for item ${itemId}`);
    return [];
  } catch (error) {
    console.error(`Error fetching active rules for item ${itemId}:`, error);
    return [];
  }
} 